export default "__VITE_ASSET__DimawdKL__"